import { Injectable } from '@angular/core';
import { IID_PRATICA_IRU_CUSTOMER } from '@common/interfaces/interfaceData';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { IIDPraticaIruCustomerQuery } from './iidPraticaIruCustomer.query';
import { IIDPraticaIruCustomerStore } from './iidPraticaIruCustomer.store';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.IID_PRATICA_IRU_CUSTOMER)
export class IIDPraticaIruCustomerService extends CrudService<IID_PRATICA_IRU_CUSTOMER, IIDPraticaIruCustomerStore, IIDPraticaIruCustomerQuery> {
  constructor(
    protected store: IIDPraticaIruCustomerStore,
    public query: IIDPraticaIruCustomerQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy
  ) {
    super(
      Topics.IID_PRATICA_IRU_CUSTOMER,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }
}
